import { render, staticRenderFns } from "./distributeClass.vue?vue&type=template&id=4df8a018&"
import script from "./distributeClass.vue?vue&type=script&lang=js&"
export * from "./distributeClass.vue?vue&type=script&lang=js&"
import style0 from "./distributeClass.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports